import React, { FC, useState, useRef } from "react";
import classNames from "classnames";
import { useI18next } from "gatsby-plugin-react-i18next";
import { Globe } from "@app/components/common/icons";
import { useOutsideClick } from "@app/hooks";

export const LanguageSwitcher: FC = () => {
  const { languages, language, originalPath, changeLanguage } = useI18next();
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef(null);

  useOutsideClick(ref, () => setIsOpen(false));

  const onToggleLanguageDropdown = () => setIsOpen(!isOpen);

  return (
    <div ref={ref}>
      <button
        className={classNames("flex items-center gap-3")}
        onClick={onToggleLanguageDropdown}
      >
        <Globe className="stroke-primary-content h-6 w-6" />
        <span className="text-primary-content capitalize">{language}</span>
      </button>
      <ul
        className={classNames(
          "absolute -bottom-5 flex translate-y-full flex-col gap-y-1 rounded-2xl px-9 py-6",
          "bg-nav-light text-regular text-base-content duration-300",
          { "invisible opacity-0": !isOpen, "visible opacity-100": isOpen },
        )}
      >
        {languages
          .filter((lang) => lang !== language)
          .map((lang) => (
            <li
              key={lang}
              onClick={() => {
                changeLanguage(lang, originalPath);
                setIsOpen(!isOpen);
              }}
              className="hover:text-base-content/50 cursor-pointer capitalize duration-300"
            >
              {lang}
            </li>
          ))}
      </ul>
    </div>
  );
};
